import { useEffect, useState } from "react";

import { axiosInstance } from "@/apis/core";
import {
  CAMPUS_CD,
  Community,
  Garret,
  Leaf,
  OrgTreeState,
} from "@/pages/Admin/components/OrgManagement/types";

/* 조직(공동체/다락방/순) 데이터 + 선택 상태. OrgManagement 메인 컴포넌트에서만 호출된다. */
const useOrgTree = (): OrgTreeState => {
  // 데이터
  const [communities, setCommunities] = useState<Community[]>([]);
  const [garrets, setGarrets] = useState<Garret[]>([]);
  const [leafs, setLeafs] = useState<Leaf[]>([]);

  // 선택 상태
  const [selectedCmtCd, setSelectedCmtCd] = useState<string | null>(null);
  const [selectedGarCd, setSelectedGarCd] = useState<string | null>(null);
  const [selectedLeafCd, setSelectedLeafCd] = useState<string | null>(null);

  // ---- 데이터 로드 ----

  useEffect(() => {
    loadCommunities();
  }, []);

  useEffect(() => {
    if (selectedCmtCd) {
      loadGarrets(selectedCmtCd);
      setSelectedGarCd(null);
      setSelectedLeafCd(null);
      setLeafs([]);
    } else {
      setGarrets([]);
      setLeafs([]);
      setSelectedGarCd(null);
      setSelectedLeafCd(null);
    }
  }, [selectedCmtCd]);

  useEffect(() => {
    if (selectedGarCd && selectedCmtCd) {
      loadLeafs(selectedCmtCd, selectedGarCd);
      setSelectedLeafCd(null);
    } else {
      setLeafs([]);
      setSelectedLeafCd(null);
    }
  }, [selectedGarCd]);

  const loadCommunities = async () => {
    try {
      const res = await axiosInstance.get(
        "/user-service/api/v1/community/list",
        {
          params: { cpsCd: CAMPUS_CD },
        },
      );
      const list: Community[] = Array.isArray(res.data) ? res.data : [];

      setCommunities(list.filter(c => c.delYn !== "Y"));
    } catch (e) {
      console.error(e);
    }
  };

  const loadGarrets = async (cmtCd: string) => {
    try {
      const res = await axiosInstance.get("/user-service/api/v1/garret/list", {
        params: { cpsCd: CAMPUS_CD, cmtCd },
      });
      const list: Garret[] = Array.isArray(res.data) ? res.data : [];

      setGarrets(list.filter(g => g.delYn !== "Y"));
    } catch (e) {
      console.error(e);
    }
  };

  const loadLeafs = async (cmtCd: string, garCd: string) => {
    try {
      const res = await axiosInstance.get("/user-service/api/v1/leaf/list", {
        params: { cpsCd: CAMPUS_CD, cmtCd, garCd },
      });
      const list: Leaf[] = Array.isArray(res.data) ? res.data : [];

      setLeafs(list.filter(l => l.delYn !== "Y"));
    } catch (e) {
      console.error(e);
    }
  };

  return {
    communities,
    garrets,
    leafs,
    selectedCmtCd,
    setSelectedCmtCd,
    selectedGarCd,
    setSelectedGarCd,
    selectedLeafCd,
    setSelectedLeafCd,
    loadCommunities,
    loadGarrets,
    loadLeafs,
  };
};

export default useOrgTree;
